import uuidv4 from "uuid/v4";
import h from "./h";
import utils from "./utils";

const yeuCauHoTroItems = [];

export default {
  search_(yeuCauHoTroItems, searchForm) {
    return h.findAll(yeuCauHoTroItems, item => {
      return (
        (!searchForm.query ||
          (utils.like(item.title, searchForm.query) ||
            utils.like(item.title, searchForm.query) ||
            utils.like(item.note, searchForm.query) ||
            utils.like(item.location, searchForm.query) ||
            utils.like(item.requestTypeName, searchForm.query))) &&
        (!searchForm.status || item.status === searchForm.status)
      );
    });
  },

  findById(id) {
    return Promise.resolve({
      data: h.find(yeuCauHoTroItems, item => item.id === id)
    });
  },

  findAll(searchForm, pagable) {
    return Promise.resolve({
      data: this.search_(yeuCauHoTroItems, searchForm).slice(
        pagable.page * pagable.size,
        (pagable.page + 1) * pagable.size - 1
      )
    });
  },

  insert(submitForm, requestor) {
    return new Promise(resolve => {
      yeuCauHoTroItems.push({
        id: uuidv4(),
        title: submitForm.title,
        note: submitForm.note,
        location: submitForm.location,
        processTime: submitForm.processTime,
        requestTypeName: submitForm.requestTypeName,
        status: "waitForApproving",
        requestor: `${requestor.fullName} (${requestor.positionName} ${requestor.deptName})`
      });
      resolve();
    });
  },

  update(id, submitForm) {
    return new Promise(resolve => {
      this.findById(id).then(response => {
        let item = response.data;
        item.title = submitForm.title;
        item.note = submitForm.note;
        item.location = submitForm.location;
        item.processTime = submitForm.processTime;
        item.requestTypeName = submitForm.requestTypeName;

        resolve();
      });
    });
  },

  approve(id) {
    return new Promise(resolve => {
      this.findById(id).then(response => {
        response.data.status = "approved";
        resolve();
      });
    });
  },

  delete(id) {
    return new Promise(resolve => {
      this.findById(id).then(response => {
        response.data.status = "deleted";
        resolve();
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/hoTroYeuCauService.js